//Initialize Accordion
if (document.querySelector(".accordion-container")) {
	new Accordion(".accordion-container");
}

//Carousel Script
if (document.querySelector(".glide__slides")) {
	var allSlides = document.querySelectorAll(".glide");
	var allSlidesArray = Array.prototype.slice.call(allSlides);
	allSlidesArray.forEach((slide) => {
		const glide = new Glide(slide, {
			type: "slider",
			perView: 1,
			perTouch: 1,
			focusAt: "center",
			autoplay: false,
			accessibility: true,
			startAt: 1,
			rewind: true,
			classes: {
				disabledArrow: "glide__arrow--disabled",
			},
			peek: {
				before: 0,
				after: 0,
			},
			perSwipe: "|",
			breakpoints: {
				800: {
					perView: 1,
					startAt: 1,
					peek: 50,
					dots: true,
				},
			},
		}).mount();
	});
}

//Check if Header Button link is external
const btns = document.querySelectorAll(".wp-block-button__link");
const allBtns = Array.prototype.slice.call(btns);
const currentHost = window.location.hostname;

let externalText = document.createElement("span");
externalText.append(document.createTextNode("link will open external site"));
externalText.classList.add("screen-reader-text");

if (btns) {
	allBtns.forEach((btn) => {
		if (btn.hasAttribute("href")) {
			let ctaLink = btn.getAttribute("href").split("/");

			if (ctaLink[2] !== currentHost) {
				btn.classList.add("external-link");
				btn.append(externalText);
			}
		}
	});
}
if (document.querySelector(".cta-btn")) {
	let currentHost = window.location.hostname;
	let ctaBtn = document.querySelector(".cta-btn");
	let ctaLink = ctaBtn.getAttribute("href").split("/");

	if (ctaLink[0] !== currentHost) {
		ctaBtn.classList.add("external-link");
		ctaBtn.append(externalText);
	}
}


////Pagination
if (document.querySelector(".navigation-pagination")) {
	let paginationList = document.querySelectorAll(".navigation-pagination ul li");

	if (paginationList[0].classList.contains("active")) {
		paginationList[0].style.position = "relative";
	}

	if (paginationList[paginationList.length - 1].classList.contains("active")) {
		paginationList[paginationList.length - 1].style.position = "relative";
	}
}

////Masonary
if (document.querySelector(".allcontainer")) {
	var elem = document.querySelector(".allcontainer");
	var msnry = new Masonry(elem, {
		// options
		itemSelector: ".item",
		columnWidth: ".grid-sizer",
		gutter: 15,
	});

	//Filters
	// const filterBtn = document.querySelectorAll('.filters button');
	// var allfilterBtn = Array.prototype.slice.call(filterBtn);
	//let allblocks = document.querySelectorAll('.item');
	let allblocks = Array.prototype.slice.call(document.querySelectorAll(".item"));
	let selectedValue;
	let selectedOption;
	let availableItems;
	let buttons = document.querySelectorAll(".filters button"); //returns a nodelist

	for (let i = 0; i < buttons.length; i++) {
		buttons[i].addEventListener("click", onClickChange);
	}

	//Click Filter
	function onClickChange() {
		selectedValue = this.value;
		// if(selectedValue !== 'all'){
		//   allblocks = document.querySelectorAll('.item.block');
		// }
		allblocks.forEach(function (block) {
			block.classList.remove("block");

			if (selectedValue == "all") {
				block.classList.add("block");
			}

			if (block.getAttribute("data-cat") == selectedValue) {
				block.classList.add("block");
			}
		});
		msnry.layout();

		availableItems = Array.prototype.slice.call(document.querySelectorAll(".item.block"));
		document.getElementById("select").addEventListener("change", onSelectChange);
	}

	availableItems = Array.prototype.slice.call(document.querySelectorAll(".item.block"));

	document.getElementById("select").addEventListener("change", onSelectChange);

	function onSelectChange() {
		selectedOption = this.value;

		availableItems.forEach(function (item) {
			item.classList.remove("block");

			if (selectedOption == "all") {
				item.classList.add("block");
			}

			if (item.getAttribute("data-tag") == selectedOption) {
				item.classList.add("block");
			}
		});

		//Filter Click
		for (let i = 0; i < buttons.length; i++) {
			buttons[i].addEventListener("click", onClickChange);
		}

		msnry.layout();
	}

	/////Script_AJAX
	/* Ajax functions */
	$(document).ready(function () {
		//onclick
		$("#loadMore").on("click", function (e) {
			e.preventDefault();
			//init
			var that = $(this);
			var page = $(this).data("page");
			var newPage = page + 1;
			var ajaxurl = that.data("url");
			//ajax call
			$.ajax({
				url: ajaxurl,
				type: "post",
				data: {
					page: page,
					action: "ajax_script_load_more",
				},
				error: function (response) {
					console.log(response);
				},
				success: function (response) {
					//check
					if (response == 0) {
						$(".allcontainer").append('<div class="text-center no-more-post"><h4>You reached the end of the line!</h4><p>No more posts to load.</p></div>');
						$("#loadMore").hide();
					} else {
						that.data("page", newPage);
						$("#ajax-primary").append(response);

						msnry = new Masonry(elem, {
							// options
							itemSelector: ".item",
							columnWidth: ".grid-sizer",
							gutter: 15,
						});

						msnry.layout();
					}
				},
			});
		});
	});
}

//Breadcrumb Spacing
if (document.querySelector(".breadcrumb-container")) {
	document.querySelector(".content-area").style.marginTop = 0;
}

//Button Custom Colors Hover
var customBtn = $(".wp-block-button a.has-text-color.has-background");

customBtn.each(function (index) {
	var btnbgColor = $(this).css("backgroundColor");
	var btnColor = $(this).css("color");

	$(this)
		.mouseenter(function () {
			$(this).css({
				"background-color": btnColor,
				color: btnbgColor,
				"border-color": btnColor
			});
		})
		.mouseleave(function () {
			$(this).css({
				"background-color": btnbgColor,
				color: btnColor,
				"border-color": btnbgColor
			});
		});
});

// modal code
$('.ps-trigger').on('click', function(e) {
	$('#modal-1').toggleClass("ps-show");
	e.preventDefault();
  });

$('#ps-close').on('click', function(e) {
	$('#modal-1').toggleClass("ps-show");
	e.preventDefault();
  });

  $('#mobile-ps-close').on('click', function(e) {
	$('#modal-1').toggleClass("ps-show");
	e.preventDefault();
  });
  


// $('.ps-mute').on('click', function(e) {
// 	//var myVideo_0 = document.getElementById("ps_herovideo_0");
// 	//myVideo_0.muted = false;
// 		var iframe = document.getElementsByTagName('iframe')[0];
// 		if ($(this).hasClass('mute')) {
// 			$(this).removeClass('mute');
// 			iframe.contentWindow.postMessage('{"method":"setVolume", "value":1}', '*');
// 		} else {
// 			$(this).addClass('mute');
// 			iframe.contentWindow.postMessage('{"method":"setVolume", "value":0}', '*');
// 		}
// 	e.preventDefault();
//   });

var heroiframe = document.getElementsByTagName('iframe')[0];
if(heroiframe){
let player = new Vimeo.Player(heroiframe);
let width = screen.width;
if (width > 961) {
	player.play();
} else {
	$('.ps-play-pause').text("Resume");
	player.pause();
}
}

$('.ps-play-pause').on('click', function(e) {
		var iframe = document.getElementsByTagName('iframe')[0];
		let player = new Vimeo.Player(iframe);
		player.getPaused().then(function(paused) {
			if(paused){
				$('.ps-play-pause').text("Pause");
				player.play();
			 } else {
				$('.ps-play-pause').text("Resume");
				player.pause();
			 }
		  });
	e.preventDefault();
  });


		var video_frame = document.querySelectorAll(".ps-videos-component-iframe");
		var play_btn = document.querySelectorAll(".ps-videos-component");
		var nodelist = video_frame.length;
		for (i = 0; i < nodelist; i++) {
			el = video_frame[i];
			let player = new Vimeo.Player(el);
			 player.play();
			 let width = screen.width;
			 if (width > 961) {
			 player.pause();
			$(play_btn[i]).hover(function() {
				player.play();
			}, function() {
				player.pause();
			});
		 }
		}

		$('.ps-trigger').on('click', function() {
			
			let width = screen.width;
			 if (width > 960){
				var video1  = $('.ps_herovideo_cls');
			var video2  = $('.ps_herovideo_popup_cls');
			var player1 = new Vimeo.Player(video1);
			var player2 = new Vimeo.Player(video2);
				player1.pause();
				player2.play();
				console.log('even' + width);
			 }else{
				var video1  = $('.ps_herovideo_cls');
			var video3 	= $('.ps_mobile_herovideo_popup_cls');
			var player1 = new Vimeo.Player(video1);
			var player3 = new Vimeo.Player(video3);
				player1.pause();
				player3.play();
				console.log('odd' + width);
			 }
			
			
		});

		$('.ps-close').on('click', function() {
			var video1  = $('.ps_herovideo_cls');
			var video2  = $('.ps_herovideo_popup_cls');
			// var video3 	= $('.ps_mobile_herovideo_popup_cls');
			var player1 = new Vimeo.Player(video1);
			var player2 = new Vimeo.Player(video2);
			// var player3 = new Vimeo.Player(video3);

			player1.play();
			player2.pause();
			// player3.pause();
			
		});

		$('.mobile-ps-close').on('click', function() {
			var video1  = $('.ps_herovideo_cls');
			var video2  = $('.ps_herovideo_popup_cls');
			var video3 	= $('.ps_mobile_herovideo_popup_cls');
			var player1 = new Vimeo.Player(video1);
			var player2 = new Vimeo.Player(video2);
			var player3 = new Vimeo.Player(video3);

			player1.play();
			player2.pause();
			player3.pause();
			
		});
		

  let backBtn = document.querySelector(".back-button");
  if(backBtn){
	backBtn.addEventListener('click',function(e){
		e.preventDefault();
		if(window.history.length && document.referrer != ''){
		window.history.back();
		} else {
			location.href = e.currentTarget.getAttribute('href');
		}
	});
}
function redirect_to_role(val) {
	location.href = val;
}

window.addEventListener('load', (event) => {
	$('.listingFilters').append('<div class="job-count-container"><span class="jobscount">0 jobs</span></div>');
	const queryParams = new URLSearchParams(window.location.search);
	const post_title = (queryParams.get('post_title'))?queryParams.get('post_title'):null;
	$.ajax({
	  type: 'POST',
	  url: ajax_js_vars.ajax_url,
	  dataType: 'html',
	  data: {
		action: 'ps_count_jobs',
		post_title: post_title
	  },
	  success: function (res) {
		$('.jobscount').html(+res+' jobs');
	  }
	});
});
// mobile menu accessibility
let focusonlastmenuitem= document.querySelector(".only-mobile-menu .main-navigation .menu li:last-child a");
 if(focusonlastmenuitem) {
	focusonlastmenuitem.addEventListener("keydown", function(e){
		let isTabPressed = e.key === 'Tab' || e.keyCode === 9;
		let isEnterPressed = e.keyCode === 13;
		 if(isTabPressed) {
			let focusonclosebutton= document.querySelector(".site-header .row.align-items-center .site-branding .custom-logo-link");
			focusonclosebutton.focus();
		 }
	})
 }

 var chk_content = document.querySelectorAll(".listingContent .jobsrow .listingAnchor div .ps_job_details span");
 if(chk_content) {
 for (i = 0; i < chk_content.length; i++) {
	if(chk_content[i].textContent == ''){
		chk_content[i].parentElement.parentElement.remove();
	}
 }
}